// extracted by mini-css-extract-plugin
export default {"promobanner":"promocionBanner-module--promobanner--isltC"};